// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import { Text } from '@atlaskit/primitives/compiled/text';

import { useIntl } from 'react-intl';

import messages from '../messages';

import type { SpotlightTourStepProps } from '../types';

import { type JSX } from 'react/jsx-runtime';

export const IntroductionStep = ({ onDismiss, onNext }: SpotlightTourStepProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onNext,
					text: formatMessage(messages.changeboardingNextButton),
				},
				{
					appearance: 'subtle',
					onClick: onDismiss,
					text: formatMessage(messages.changeboardingDismissButton),
				},
			]}
			actionsBeforeElement="1/2"
			dialogPlacement="left top"
			dialogWidth={300}
			heading={formatMessage(messages.changeboardingTitle)}
			key="jira-filter-refinement-spotlight-popup-introduction"
			pulse={false}
			target="jira-filter-refinement-spotlight-popup"
		>
			<Stack space="space.150">
				<Text>{formatMessage(messages.changeboardingDescriptionFilterByStatusAndPriority)}</Text>
				<Text>{formatMessage(messages.changeboardingDescriptionMoreImprovements)}</Text>
			</Stack>
		</Spotlight>
	);
};
